export type AuthIntent = 'login' | 'signup';

const AUTH_PARAM = 'auth';

/** The address that opens the home page with the login or sign-up modal; the retired /auth pages redirect to it. */
export const authIntentUrl = (intent: AuthIntent) => `/?${AUTH_PARAM}=${intent}`;

/** Which modal the URL asks for. Read once on mount, then {@link removeAuthIntentParam}. */
export function peekAuthIntent(): AuthIntent | null {
  const intent = new URLSearchParams(window.location.search).get(AUTH_PARAM);
  return intent === 'login' || intent === 'signup' ? intent : null;
}

/** Drops the parameter so a reload does not open the modal again. */
export function removeAuthIntentParam(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(AUTH_PARAM)) return;
  url.searchParams.delete(AUTH_PARAM);
  window.history.replaceState(window.history.state, '', url.toString());
}
